import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import { PageSerializersBooksShow } from "types/serializers";
import ReportBookButtonContent from "components/ReportDropdown/ReportBookButton/ReportBookButtonContent";
import ApplyLibrarianButton from "./ApplyLibrarian";

export default function LoggedInBookLinks({
  book,
}: {
  book: PageSerializersBooksShow;
}) {
  const isLoggedIn = useIsLoggedIn();

  return (
    <div className="flex gap-2 justify-between items-center">
      {isLoggedIn ? <ReportBookButtonContent book={book} /> : false}
      <ApplyLibrarianButton />
    </div>
  );
}
